import { RefObject, useEffect } from 'react';

export default function useOutsideClick(
  ref: RefObject<HTMLElement>,
  handler: (e: any) => void,
  exceptRefs?: RefObject<HTMLElement>[]
): void {
  useEffect(() => {
    const listener = (event: any) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      if (exceptRefs?.some((ref) => ref.current?.contains(event.target))) {
        return;
      }
      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler, exceptRefs]);
}
